import { useState } from "react";
import {
  RequestUpdatePersonalUserInfoRequest,
  UsersUpdatePersonalUserInfoPostRequest,
  UsersApi,
} from "../../services/OpenAPI";
import { createConfiguration } from "./common";

export const useApiUpdatePersonalUserInfo = () => {
  const [result, setResult] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const updatePersonalUserInfo = async (
    req: RequestUpdatePersonalUserInfoRequest
  ) => {
    setIsLoading(true);
    setError(null);

    try {
      setIsLoading(true);
      const config = createConfiguration();
      const request: UsersUpdatePersonalUserInfoPostRequest = {
        req,
      };

      const api = new UsersApi(config);
      const response = await api.usersUpdatePersonalUserInfoPost(request);
      setResult(response);
      return response;
    } catch (err) {
      setError("更新に失敗しました");
      console.error(err);
      return null;
    } finally {
      setIsLoading(false);
    }
  };

  return { updatePersonalUserInfo, error, isLoading };
};
